module.exports = __webpack_public_path__ + "img/bathtub.ea77d689.png";